import axios from 'axios';
import store from '@/store';
import qs from 'qs';
import Message from '@/utils/message';
import { logout } from '@/utils/logout';

let loadingInstance = null;
let isRefreshing = false; // refresh_token是否刷新成功
let queueRequests = []; // refresh_token刷新并行接口集合队列

axios.defaults.timeout = 15000; // 响应时间
axios.defaults.withCredentials = false;
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.request.use(
    config => {
        return store.dispatch('GetToken').then(token => {
            if (token && !config.url.includes('auth/refresh_token')) {
                config.headers.common['Authorization'] = token.token_type + ' ' + token.access_token;
            }
            return config;
        });
    },
    error => {
        Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        // 关闭全局按钮Loading响应
        store.dispatch('CancalLoading');
        if (response.status !== 200) {
            if (response.status === 208) {
                errorLogout('您的登录状态已失效，请重新登录。', response.status);
            }
            return Promise.reject(response);
        }
        return response;
    },
    error => {
        const { response } = error;
        if (response) {
            // 错误处理
            if (error.response.config.url.includes('/login')) {
                return Promise.reject(error.response);
            }
            loadingInstance && loadingInstance.close();
            let { status, data: { message } } = response;
            if (!message) {
                switch (status) {
                    case 401:
                        const { config } = error.response;
                        if (!isRefreshing) {
                            isRefreshing = true;
                            return store.dispatch('GetToken')
                                .then(token => {
                                    if (token && token.refresh_token && token.isPastDue) {
                                        config.headers.Authorization = token.token_type + ' ' + token.access_token;
                                        queueRequests.forEach(cb => cb(token));
                                        // 重试完清空这个队列
                                        queueRequests = [];
                                        return axios(config);
                                    } else {
                                        errorLogout('您的帐号在另一地点登录，您已被迫退出！', 403);
                                    }
                                })
                                .finally(() => {
                                    isRefreshing = false;
                                });
                        } else {
                            return new Promise(resolve => {
                                // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
                                queueRequests.push(token => {
                                    config.headers.Authorization = token.token_type + ' ' + token.access_token;
                                    config.url = config.url.substr(config.url.indexOf('api/') + 4);
                                    resolve(axios(config));
                                });
                            });
                        }
                        break;
                    case 403:
                        message = '您的登录状态已失效，请重新登录。';
                        break;
                    case 424:
                        message = error.response.data.error;
                        break;
                    default:
                        message = '请求失败！';
                }
            }
            errorLogout(message, status);
            return Promise.reject(response);
        } else {
            // 请求超时
            if (error.message.includes('timeout')) {
                console.log('超时了');
                Message({
                    type: 'error',
                    message: '请求已超时，请刷新或检查互联网连接'
                });
            } else {
                // 断网
                console.log('断网了');
                Message({
                    type: 'error',
                    message: '请检查网络是否已连接'
                });
            }
        }
    }
);

function errorLogout(message, status) {
    Message({
        message,
        type: 'error',
        onClose() {
            if (status === 403) {
                logout();
            }
        }
    });
}

// oauth路径的请求
export function loginFetch(options) {
    return new Promise((resolve, reject) => {
        var ObjAPI = store.getters.objApi;
        axios
            .post(ObjAPI.OAUTH_API + options.url, options.data, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true,
                transformRequest: [
                    function(data) {
                        return qs.stringify(data);
                    }
                ]
            })
            .then(response => {
                const res = response.data;
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
}

// base路劲的表单数据post
export function post(options) {
    return new Promise((resolve, reject) => {
        var ObjAPI = store.getters.objApi;
        axios
            .post(ObjAPI.BASE_API + options.url, options.data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                },
                withCredentials: true,
                transformRequest: [
                    function(data) {
                        return qs.stringify(data);
                    }
                ]
            })
            .then(response => {
                const res = response.data;
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
}

// base路劲的get请求
export function get(options) {
    return new Promise((resolve, reject) => {
        var ObjAPI = store.getters.objApi;
        axios
            .get(
                ObjAPI.BASE_API + options.url, { params: options.data }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }
            )
            .then(response => {
                const res = response.data;
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
}

// base路劲的json数据post
export function postJson(options) {
    return new Promise((resolve, reject) => {
        var ObjAPI = store.getters.objApi;
        axios
            .post(ObjAPI.BASE_API + options.url, options.data, {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            })
            .then(response => {
                const res = response.data;
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
}

// base路劲的delete请求
export function deleteData(options) {
    return new Promise((resolve, reject) => {
        var ObjAPI = store.getters.objApi;
        axios
            .delete(
                ObjAPI.BASE_API + options.url, { params: options.data }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                    withCredentials: true
                }
            )
            .then(response => {
                const res = response.data;
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
}

// base路劲put请求
export function put(options) {
    return new Promise((resolve, reject) => {
        var ObjAPI = store.getters.objApi;
        axios
            .put(ObjAPI.BASE_API + options.url, options.data, {
                headers: { Accept: '*/*' },
                withCredentials: true,
                transformRequest: [
                    function(data) {
                        return qs.stringify(data);
                    }
                ]
            })
            .then(response => {
                const res = response.data;
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
}

// base路劲的json数据delete
export function postJsonDelete(options) {
    return new Promise((resolve, reject) => {
        var ObjAPI = store.getters.objApi;
        axios
            .delete(
                ObjAPI.BASE_API + options.url, { data: options.data }, {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            )
            .then(response => {
                const res = response.data;
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
}

/**
 * blob下载
 * @param {String} url 请求地址
 * @param {String} method 请求方式 默认`get`
 * @param {Object} data 请求数据
 */
export function exportFile({ url = '', data = {}, method = 'get' }) {
    return new Promise((resolve, reject) => {
        const isPost =
            method.toLocaleUpperCase() === 'POST' ? {
                headers: { 'Content-Type': 'application/json' },
                data
            } : {
                params: data
            };
        const downConfig = {
            withCredentials: true,
            responseType: 'blob',
            ...isPost
        };
        axios
            [method](store.getters.objApi.BASE_API + url, downConfig)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    }).catch(error => {
        return Promise.reject(error);
    });
}


// WEBPACK FOOTER //
// ./src/utils/fetch.js